import React, { useEffect, useRef } from 'react'
import { styled } from '@moonpig/launchpad-utils'
import { system as s } from '@moonpig/launchpad-system'

type InternalUserPanelProps = {
  productId: string
  salesPerDay?: number
  clickRankDocumentCount: number
  publishDate?: Date
  hasDynamicImage: boolean
}

const StyledList = styled.ul`
  ${s({
    position: 'absolute',
    width: '100%',
    zIndex: 4,
    bgcolor: 'colorBackgroundSite',
    border: 1,
    typography: 'typeBodyCaption',
    borderColor: 'colorBodyText',
    color: 'colorBodyText',
    p: 5,
  })}
  opacity: 0.95;
`

export const InternalUserPanel: React.FC<InternalUserPanelProps> = ({
  productId,
  clickRankDocumentCount,
  publishDate,
  hasDynamicImage,
}) => {
  const formattedDate = useRef<string | null>(null)

  useEffect(() => {
    if (publishDate) {
      formattedDate.current = publishDate.toLocaleDateString()
    }
  }, [publishDate])

  return (
    <StyledList role="list">
      <li>
        <strong>Product No.:</strong> {productId}
      </li>
      <li>
        <strong>ClickRank Event Count: </strong>
        <span>{clickRankDocumentCount}</span>
      </li>
      <li>
        <strong>Publish Date:</strong> {formattedDate.current}
      </li>
      <li>
        <strong>Has Dynamic Image:</strong> {hasDynamicImage ? 'Yes' : 'No'}
      </li>
    </StyledList>
  )
}
